import { render, staticRenderFns } from "./points_account_record_list.vue?vue&type=template&id=50b43fce&scoped=true"
import script from "./points_account_record_list.vue?vue&type=script&lang=js"
export * from "./points_account_record_list.vue?vue&type=script&lang=js"
import style0 from "./points_account_record_list.vue?vue&type=style&index=0&id=50b43fce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b43fce",
  null
  
)

export default component.exports